import { render, staticRenderFns } from "./chooseModuleDialog.vue?vue&type=template&id=2af5a810"
import script from "./chooseModuleDialog.vue?vue&type=script&lang=js"
export * from "./chooseModuleDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports